/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EditorProjectPartialUpdate
 */
export interface EditorProjectPartialUpdate {
    /**
     * 
     * @type {number}
     * @memberof EditorProjectPartialUpdate
     */
    file?: number;
    /**
     * 
     * @type {number}
     * @memberof EditorProjectPartialUpdate
     */
    parent?: number;
    /**
     * 
     * @type {string}
     * @memberof EditorProjectPartialUpdate
     */
    parentPath?: string;
    /**
     * 
     * @type {number}
     * @memberof EditorProjectPartialUpdate
     */
    existingFile?: number;
    /**
     * 
     * @type {string}
     * @memberof EditorProjectPartialUpdate
     */
    format?: string;
    /**
     * 
     * @type {object}
     * @memberof EditorProjectPartialUpdate
     */
    project?: object;
}

export function EditorProjectPartialUpdateFromJSON(json: any): EditorProjectPartialUpdate {
    return EditorProjectPartialUpdateFromJSONTyped(json, false);
}

export function EditorProjectPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditorProjectPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : json['file'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'parentPath': !exists(json, 'parent_path') ? undefined : json['parent_path'],
        'existingFile': !exists(json, 'existing_file') ? undefined : json['existing_file'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'project': !exists(json, 'project') ? undefined : json['project'],
    };
}

export function EditorProjectPartialUpdateToJSON(value?: EditorProjectPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': value.file,
        'parent': value.parent,
        'parent_path': value.parentPath,
        'existing_file': value.existingFile,
        'format': value.format,
        'project': value.project,
    };
}


